// src\components\CustomLoader.tsx
import React from "react";
import { CircularProgress, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../stores";

interface LoaderProps {
  force?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ force = false }) => {
  const activeRequests = useSelector((state: RootState) => state.loading.activeRequests);
  const showLoader = force || activeRequests > 0;

  if (!showLoader) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="rgba(255,255,255,0.5)"
      zIndex={9999}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
